import { useLocation } from 'react-router-dom'

import {
  Box, DashboardModule,
} from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import useAssetLibraries from '@hooks/useAssetLibraries'

import AssetLibraryListItem from '../AssetLibraryListItem'

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const AgencyAssetLibraries = (props: PageContentProps) => {
  const { pageFilters } = props

  useLocation()

  const { selectedAgencyId } = useAgencySelector()

  const assetLibrariesPayload = useAssetLibraries({
    filters: {
      owner_id: selectedAgencyId,
      owner_type: 'Agency',
      ...pageFilters,
    },
    performHttpRequests: true,
    requestOptions: {
      include_asset_library_attachments_count: true,
    },
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredAssetLibraries,
    filteredAssetLibrariesCount,
    hasFilteredAssetLibraries,
    loaded,
    loading,
  } = assetLibrariesPayload

  return (
    <DashboardModule
      boxProps={{ borderBottom: `${loading ? 'none' : ''}` }}
      loading={loading && !loaded}
      title="Agency Document Libraries"
    >
      {!loading && !hasFilteredAssetLibraries && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Agency Document Libraries Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please adjust your filters or create one above
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {loaded && hasFilteredAssetLibraries && (
        <Box flexDirection="column">
          <DashboardModule.ScrollableSection>
            {filteredAssetLibraries.map(assetLibrary => (
              <AssetLibraryListItem
                assetLibrary={assetLibrary}
                key={assetLibrary.id}
              />
            ))}
          </DashboardModule.ScrollableSection>

          <DashboardModule.LoadMoreFooter
            callbacks={{ loadMore }}
            canLoadMore={canLoadMore}
            entityCount={filteredAssetLibrariesCount}
            loading={loading}
          />
        </Box>
      )}
    </DashboardModule>
  )
}

export default AgencyAssetLibraries
